module.exports = __webpack_public_path__ + "static/img/Frame12.a9990c5d.png";